import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import DirectMessageView from "./direct_message_view";
import EnableDirectMessagingPrompt from "./enable_direct_messaging_promt";
import SearchResultContent from "./search_result_content";
import DirectMessagingOverview from "./direct_messaging_overview";
import CompleteUserList from "./complete_user_list";
import {directMessageSetReceiverTagOwner} from "../../exhibition_actions";


const MainContainer = ({preselectedTagOwnerId, initialShowParticipants, translations, disableBackButton, disableCompleteUserListBackButton}) => {
  const [searchResults, setSearchResults] = useState(null);
  const [showParticipants, setShowParticipants] = useState(initialShowParticipants);
  const isDirectMessagingEnabled = useSelector((state) => state.directMessaging?.isDirectMessagingEnabled)
  const hostname = useSelector((state) => state.hostname)
  const receiverTagOwner = useSelector((state) => state.directMessaging?.receiverTagOwner)

  // This is so when returning the complete user list should be shown if initially shown
  const completeUserListSetShowParticipants = initialShowParticipants ? () => {} : setShowParticipants

  if (receiverTagOwner?.id) {
    return <DirectMessageView setSearchResults={setSearchResults} translations={translations} disableBackButton={disableBackButton} />
  } else if (!isDirectMessagingEnabled) {
    return <EnableDirectMessagingPrompt setSearchResults={setSearchResults} translations={translations} />
  } else if (searchResults) {
    return <SearchResultContent setSearchResults={setSearchResults} searchResults={searchResults}  translations={translations} />
  } else if (showParticipants) {
    return <CompleteUserList
      setShowParticipants={completeUserListSetShowParticipants}
      translations={translations}
      disabledBackButton={disableCompleteUserListBackButton}
      reloadUsersOnFilterChange={hostname.startsWith("flaveueg")}
    />
  }

  return <DirectMessagingOverview setShowParticipants={setShowParticipants} setSearchResults={setSearchResults} translations={translations} />
}

export default function DirectMessaging({preselectedTagOwnerId, translations, disableBackButton, disableCompleteUserListBackButton, initialShowParticipants, showChatsInCompleteUserList}) {
  const dispatch = useDispatch()
  const htmlContentTranslations = useSelector(state => (state.htmlContents || []).find(hc => hc.identifier == "direct_messaging.translations")?.json?.default || {})
  const whatsappStyle = true
  const safeTranslations = translations || htmlContentTranslations || {}

  useEffect(() => {
    if (preselectedTagOwnerId) {
      // Just fake the tag owner object, because the name shouldn't be displayed anyway
      // Sorry if someone has to implement this,  probably just implement a controller which fetches the tag owner object for this tag owner.
      dispatch(directMessageSetReceiverTagOwner({
        id: preselectedTagOwnerId,
        name: "",
        direct_messages_enabled: true
      }));
    }
  }, [])

  return <div className={"direct-messaging"}>
    <MainContainer
      translations={safeTranslations}
      disableBackButton={disableBackButton}
      initialShowParticipants={!!whatsappStyle}
      disableCompleteUserListBackButton={!!whatsappStyle}
    />
  </div>;
}
